/*
 *  Logos
 *    Scripts for the logos section
 *
 *  Version:
 *    1.0.0 - 2022/02/10
 */

import { CLASS_INITIALISED } from '../tools/constants/classes';
import {
  initMouseDragging,
  setOverflowClass,
} from '../tools/utilities/carousel-tools';

// Selectors
const SELECTOR_SCROLLER = '[data-logos-scroller]';
const SELECTOR_WRAPPER = '[data-logos-wrapper]';

document.querySelectorAll<HTMLElement>(SELECTOR_SCROLLER).forEach((element) => {
  if (element.classList.contains(CLASS_INITIALISED)) return;
  element.classList.add(CLASS_INITIALISED);

  // Set initial overflow class
  setOverflowClass(element, SELECTOR_WRAPPER);

  // Change overflow class as needed on resize
  window.addEventListener('resize', () =>
    setOverflowClass(element, SELECTOR_WRAPPER)
  );

  // Initialize dragging
  initMouseDragging(element);
});
